import hero from '../../images/ujjal.jpg';
import SideNavigation from '../UI/SideNavigation';
import { TypeAnimation } from 'react-type-animation';
import { FaExternalLinkAlt } from "react-icons/fa";
import '../UI/css/heroSection.css';

const HeroSection = () => {
    return (
        <div id="hero">
            <div className="hero-section">
                <div className="hero-bg"></div>
            </div>
            <div className="container">
                <div className="position-relative row">
                    <div className='col-12 col-md-6'>
                        <div className="hero-image-section">
                            <img src={hero} alt="ujjal-zaman-image" />
                        </div>
                    </div>
                    <div className='col-12 col-md-6'>
                        <div>
                            <div className="hero-overview position-absolute pb-3 px-3">
                                <h4 className='fst-italic text-white'>HI THERE! </h4>
                                <h1 className='text-white'>I'M <span className="hero-name">UJJAL <span style={{ color: '#e9ac04' }}>ZAMAN</span></span></h1>
                                <TypeAnimation
                                    sequence={[
                                        'I M',
                                        1000,
                                        'FRONT-END DEVELOPER',
                                        2000,
                                        'BACKEND DEVELOPER'
                                    ]}
                                    wrapper="span"
                                    cursor={true}
                                    repeat={Infinity}
                                    style={{ fontSize: '1em', display: 'inline-block', color: '#e9ac04', fontWeight: 700 }}
                                />
                            </div>
                            <div className='d-flex flex-column mt-5 overview-text-content'>
                                <div className='d-flex justify-content-center order-0 order-md-1'>
                                    <button className="resume-btn">
                                        <a href="https://drive.google.com/file/d/1GEYvUD7g0UEldrNOwuPBe8oGIH16bJir/view" target='_blank'>Resume</a>
                                        <FaExternalLinkAlt />
                                    </button>
                                </div>

                                <div className='order-1 order-md-0'>
                                    <p className='text-white p-3'>Experienced Full-Stack Web Developer with 2.5+ years of expertise. <br /> Specializing in user-centric web applications,<br /> proficient in both front-end and back-end development.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="hero-side-navigation">
                    <div className="">
                        <SideNavigation />
                    </div>
                </div>
        </div >
    );
};

export default HeroSection;